/**
 * Utility functions for date formatting and parsing
 */

/**
 * Format date from YYYY-MM-DD to DD/MM/YYYY
 */
export const formatDateToDDMMYYYY = (dateStr) => {
  if (!dateStr) return '';
  
  // If already in DD/MM/YYYY format, return as is
  if (dateStr.includes('/')) return dateStr;
  
  // Convert from YYYY-MM-DD to DD/MM/YYYY
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
};

/**
 * Format date from DD/MM/YYYY to YYYY-MM-DD (for input[type="date"])
 */
export const formatDateToYYYYMMDD = (dateStr) => {
  if (!dateStr) return '';
  
  // If already in YYYY-MM-DD format, return as is
  if (dateStr.includes('-')) return dateStr;
  
  // Convert from DD/MM/YYYY to YYYY-MM-DD
  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

/**
 * Custom date input component that displays and accepts DD/MM/YYYY
 */
export const DateInput = ({ value, onChange, name, className, ...props }) => {
  const handleChange = (e) => {
    let inputValue = e.target.value;
    
    // Remove non-numeric characters except /
    inputValue = inputValue.replace(/[^\d/]/g, '');
    
    // Auto-format as DD/MM/YYYY while typing
    if (inputValue.length >= 2 && !inputValue.includes('/')) {
      inputValue = inputValue.slice(0, 2) + '/' + inputValue.slice(2);
    }
    if (inputValue.length >= 5 && inputValue.split('/').length === 2) {
      const parts = inputValue.split('/');
      inputValue = parts[0] + '/' + parts[1].slice(0, 2) + '/' + parts[1].slice(2);
    }
    
    // Limit to DD/MM/YYYY format (10 characters)
    if (inputValue.length > 10) {
      inputValue = inputValue.slice(0, 10);
    }
    
    // Call parent onChange with DD/MM/YYYY format
    onChange({
      target: {
        name: name,
        value: inputValue
      }
    });
  };
  
  return (
    <input
      type="text"
      name={name}
      className={className || 'form-control'}
      value={value || ''}
      onChange={handleChange}
      placeholder="DD/MM/YYYY"
      maxLength="10"
      {...props}
    />
  );
};
